import AddEmployeeActionType from './AddEmployee.types';

export const addEmployeeStart = (employeeData: any) => ({
	type: AddEmployeeActionType.ADD_EMPLOYEE_START,
	payload: employeeData,
});

export const addEmployeeSuccess = (employeeData: any) => ({
	type: AddEmployeeActionType.ADD_EMPLOYEE_SUCCESS,
	payload: employeeData,
});

export const addEmployeeFailure = (error: unknown) => ({
	type: AddEmployeeActionType.ADD_EMPLOYEE_FAILURE,
	payload: error,
});

export const addEmployeeResponseChanged = () => ({
	type: AddEmployeeActionType.ADD_EMPLOYEE_RESPONSE_CHANGED,
});

export const addEmployeeResponseRestStart = () => ({
	type: AddEmployeeActionType.ADD_EMPLOYEE_RESPONSE_REST_START,
});

export const getEmployeeNameAndIDStart = (employeeData: any) => ({
	type: AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_START,
	payload: employeeData,
});

export const getEmployeeNameAndIDSuccess = (employeeData: any) => ({
	type: AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_SUCCESS,
	payload: employeeData,
});

export const getEmployeeNameAndIDFailure = (employeeData: any) => ({
	type: AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_FAILURE,
	payload: employeeData,
});

export const getEmployeeNameAndIDResponseChanged = () => ({
	type: AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_RESPONSE_CHANGED,
});

export const getEmployeeNameAndIDResponseRestStart = () => ({
	type: AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_RESPONSE_REST_START,
});
